var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpUsercontrol",
    {
      attrs: {
        loading: _vm.loading,
        reloading: _vm.reloading,
        loaded: _vm.loaded,
        error: _vm.error
      },
      on: {
        reload: function($event) {
          return _vm.evh_7315092382398562_reload($event, {})
        }
      }
    },
    [
      _c("ItpBox", { staticClass: "mb-2", attrs: { alignItems: "center" } }, [
        _c("strong", [
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("pgettext")("Versions", "Register")) +
              "\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _vm.register.versions.data
        ? _c("ItpDataTable", {
            attrs: {
              rowKeyField: "id",
              tableId: "registerVersions",
              paging: _vm.b_5962862420439144_paging,
              editable: !_vm.register.isReadonly,
              sortable: _vm.b_5962862420439144_sortable,
              value: _vm.register.versions.data,
              rowTemplate: _vm.b_5962862420439144_rowTemplate,
              columns: _vm.b_5962862420439144_columns
            },
            on: {
              save: function($event) {
                return _vm.evh_5962862420439144_save($event, {})
              },
              "save-completed": function($event) {
                return _vm.evh_5962862420439144_saveCompleted($event, {})
              },
              delete: function($event) {
                return _vm.evh_5962862420439144_delete($event, {})
              },
              "delete-completed": function($event) {
                return _vm.evh_5962862420439144_deleteCompleted($event, {})
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }